// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import SystemSelectedClaimsModalBody from './system-selected-claims-modal-body';
import SystemSelectedClaimsModalHeader from './system-selected-claims-modal-header';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

const SystemSelectedClaimsModal = props =>
    <section className='system-selected-claims-modal'>
        <WarrantyMediumModal isOpen={props.isSystemSelectedClaimsModalVisible}>
            <SystemSelectedClaimsModalHeader
                onModalClose={props.onModalClose}
            />
            <SystemSelectedClaimsModalBody
                dateFieldPlaceholder={props.dateFieldPlaceholder}
                onSelectClaims={props.onSelectClaims}
            />
        </WarrantyMediumModal>
    </section>;

SystemSelectedClaimsModal.displayName = 'SystemSelectedClaimsModal';
SystemSelectedClaimsModal.propTypes = {
    dateFieldPlaceholder: PropTypes.string.isRequired,
    isSystemSelectedClaimsModalVisible: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    onSelectClaims: PropTypes.func.isRequired
};

export default SystemSelectedClaimsModal;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/system-selected-claims-modal/index.js